import { ThumbsDown, ThumbsUp } from '@components/icons'
import { Content } from '@prismicio/client'
import { SliceComponentProps } from '@prismicio/react'
import cn from 'clsx'
import { useRouter } from 'next/router'
import { useState } from 'react'
declare global {
  interface Window {
    hj: any
  }
}
/**
 * Props for `HotjarSurveyBlock`.
 */
export type HotjarSurveyBlockProps =
  SliceComponentProps<Content.HotjarSurveyBlockSlice>

/**
 * Component for "HotjarSurveyBlock" Slices.
 * Not hot jar block any more as we removed the hotjar script from the site
 * Its submitting the feed back directly to shopify metaobject
 */
const HotjarSurveyBlock = ({ slice }: HotjarSurveyBlockProps): JSX.Element => {
  const { asPath, query, locale } = useRouter()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const orderId = query.orderId
  const [clicked, setClicked] = useState(false)
  const {
    title,
    description,
    yes_option_translation,
    no_option_translation,
    paddingbottom,
    paddingtop,
    background_colour,
    post_purchase_feedback_block,
  } = slice?.primary || {}
  const sectionStyles = {
    paddingBottom: `${paddingbottom}px` || '0px',
    paddingTop: `${paddingtop}px` || '0px',
    backgroundColor: background_colour || '#F1F1F1',
  }

  const handleSubmit = async (comment: string) => {
    if (isSubmitting || isSuccess) return
    setIsSubmitting(true)
    try {
      const response = await fetch('/api/feedback/page-content-submit', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          comment,
          page_url: asPath,
          locale,
        }),
      })
      const result = await response.json()
      setIsSuccess(result?.handle ?? false)
    } catch (err) {
      console.log(err)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleUsefulInformationFeedbackSurvey = () => {
    setClicked(true)
    const comment = orderId ? `Thumbs up: OrderId : ${orderId}` : 'Thumb up'
    handleSubmit(comment)
  }
  const handleImprovementSuggestionsSurvey = () => {
    setClicked(true)
    const comment = orderId ? `Thumbs down: OrderId : ${orderId}` : 'Thumb down'
    handleSubmit(comment)
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      style={sectionStyles}
      key={`${locale}-${asPath}`}
    >
      <div
        className={cn(
          'wrapper flex flex-col items-center justify-center gap-y-6 bg-white py-10',
          { '!max-w-216': post_purchase_feedback_block }
        )}
      >
        <div className="flex flex-col items-center justify-center gap-y-4">
          <div className="heading-mobile-4 md:heading-4 ">{title}</div>
          <div className="md:body-large body-1">
            {clicked ? 'Thank you for your feedback!' : description}
          </div>
        </div>
        <div className="flex gap-x-6">
          <button
            disabled={clicked}
            onClick={handleUsefulInformationFeedbackSurvey}
            className={cn('flex flex-col items-center justify-center gap-y-1', {
              'cursor-not-allowed': clicked,
            })}
          >
            <ThumbsUp />
            <div className="body-2">{yes_option_translation}</div>
          </button>
          <button
            disabled={clicked}
            onClick={handleImprovementSuggestionsSurvey}
            className={cn('flex flex-col items-center justify-center gap-y-1', {
              'cursor-not-allowed': clicked,
            })}
          >
            <ThumbsDown />
            <div className="body-2">{no_option_translation}</div>
          </button>
        </div>
      </div>
    </section>
  )
}

export default HotjarSurveyBlock
